import ApiService from "./api.service";

const Notes = {
  add: async function (constructionId, content) {
    let response = await ApiService.post("/construction/" + constructionId + '/notes', content);
    return response.data;
  },
  update: async function (constructionId, noteId, content) {
    await ApiService.patch("/construction/" + constructionId + '/notes/' + noteId, content);
    return true;
  },
  load: async function (constructionId) {
    let response = await ApiService.get("/construction/" + constructionId + '/notes');
    return response.notes;
  },
  delete: async function (constructionId, noteId) {
    await ApiService.delete("/construction/" + constructionId + '/notes/' + noteId, {});
    return true;
  }
};

export default Notes;